import { gql } from "@apollo/client";

export const CREATE_BLOCKED_TIME = gql`
  mutation CreateBlockedTime(
    $input: CreateBlockedTimeInput!
    $condition: ModelBlockedTimeConditionInput
  ) {
    createBlockedTime(input: $input, condition: $condition) {
      id
      studioID
      title
      startDateTime
      endDateTime
      isFullDay
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const DELETE_BLOCKED_TIME = gql`
  mutation DeleteBlockedTime(
    $input: DeleteBlockedTimeInput!
    $condition: ModelBlockedTimeConditionInput
  ) {
    deleteBlockedTime(input: $input, condition: $condition) {
      id
      studioID
      title
      startDateTime
      endDateTime
      isFullDay
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const DELETE_BLOCKED_TIME_BLOCK_TIME_MANAGEMENT = gql`
  mutation DeleteBlockedTime(
    $input: DeleteBlockedTimeInput!
  ) {
    deleteBlockedTime(input: $input) {
      id
      studioID
      title
      startDateTime
      endDateTime
      isFullDay
    }
  }
`;

export const CREATE_AVAILABILITY = gql`
  mutation CreateAvailability($input: CreateAvailabilityInput!) {
    createAvailability(input: $input) {
      id
      studioID
      dayOfWeek
      startTime
      endTime
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_AVAILABILITY = gql`
  mutation DeleteAvailability($input: DeleteAvailabilityInput!) {
    deleteAvailability(input: $input) {
      id
      studioID
      dayOfWeek
      startTime
      endTime
      createdAt
      updatedAt
    }
  }
`;
